/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Types of execution conditions */
export enum ConditionType {
  TimeDelay,
  TokenBalance,
  PriceThreshold,
  VoteCount,
  ExternalOracle,
  CustomLogic,
}

export type ConditionTypeArgs = ConditionType;

export function getConditionTypeEncoder(): FixedSizeEncoder<ConditionTypeArgs> {
  return getEnumEncoder(ConditionType);
}

export function getConditionTypeDecoder(): FixedSizeDecoder<ConditionType> {
  return getEnumDecoder(ConditionType);
}

export function getConditionTypeCodec(): FixedSizeCodec<
  ConditionTypeArgs,
  ConditionType
> {
  return combineCodec(getConditionTypeEncoder(), getConditionTypeDecoder());
}
